
import { Link, useLocation } from "react-router-dom";
import {
  SidebarMenu,
  SidebarMenuItem,
  SidebarMenuButton,
  SidebarSeparator
} from "@/components/ui/sidebar";
import { 
  Settings, 
  User, 
  Users, 
  CalendarCheck
} from "lucide-react";

export const AdminSidebarItems = () => {
  const location = useLocation();
  console.log("AdminSidebarItems - Current path:", location.pathname);
  
  // Use improved path checking for active state
  const isActive = (path: string) => {
    // Exact match
    if (location.pathname === path) {
      return true;
    }
    
    // For other paths, check if it's a parent path
    return location.pathname.startsWith(path + "/");
  };
  
  return (
    <>
      <SidebarSeparator className="my-2" />
      <SidebarMenu>
        <SidebarMenuItem>
          <SidebarMenuButton asChild isActive={isActive("/admin")}>
            <Link to="/admin">
              <Settings className="h-4 w-4" />
              <span>Policy Admin</span>
            </Link>
          </SidebarMenuButton>
        </SidebarMenuItem>
        
        <SidebarMenuItem>
          <SidebarMenuButton asChild isActive={isActive("/employees")}>
            <Link to="/employees">
              <User className="h-4 w-4" />
              <span>Employees</span>
            </Link>
          </SidebarMenuButton>
        </SidebarMenuItem>

        <SidebarMenuItem>
          <SidebarMenuButton asChild isActive={isActive("/patients")}>
            <Link to="/patients">
              <Users className="h-4 w-4" />
              <span>Patients</span>
            </Link>
          </SidebarMenuButton>
        </SidebarMenuItem>
        
        <SidebarMenuItem>
          <SidebarMenuButton asChild isActive={isActive("/admin/leave")}>
            <Link to="/admin/leave">
              <CalendarCheck className="h-4 w-4" />
              <span>Leave Approvals</span>
            </Link>
          </SidebarMenuButton>
        </SidebarMenuItem>
        
        <SidebarMenuItem>
          <SidebarMenuButton asChild isActive={isActive("/meetings/settings")}>
            <Link to="/meetings/settings">
              <Settings className="h-4 w-4" />
              <span>Meeting Settings</span>
            </Link>
          </SidebarMenuButton>
        </SidebarMenuItem>
      </SidebarMenu>
    </>
  );
};
